import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ILoyaltyWebsiteFeature } from './loyalty-website.feature.state';
import { LoyaltyWebsiteState } from './loyalty-website.state';

export const getPaymentCardsState: MemoizedSelector<ILoyaltyWebsiteFeature, LoyaltyWebsiteState> = createFeatureSelector<
  LoyaltyWebsiteState
>(nameof<ILoyaltyWebsiteFeature>('loyaltyWebsiteFeature'));

export const isLoading = createSelector(getPaymentCardsState, (state: LoyaltyWebsiteState) => state.isLoading);
